import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import { base_path } from './environment.js';
import '../src/style/css/feather.css';
import '../src/style/css/line-awesome.min.css';
import '../src/style/scss/main.scss';
import '../src/style/icons/fontawesome/css/fontawesome.min.css';
import '../src/style/icons/fontawesome/css/all.min.css';
import { createRoot } from 'react-dom/client';

import { Provider } from 'react-redux';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance, initializeMsal } from './auth/msal';
import { redux } from 'Core/redux';
import AllRoutes from './router/router.jsx';
import { flushPersistedLogs } from './core/utils/devLogger';
import { PermissionProvider } from './core/utils/PermissionContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Suppress ResizeObserver loop error (benign error that occurs during viewport changes)
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.' || 
      e.message === 'ResizeObserver loop limit exceeded') {
    e.stopImmediatePropagation();
    return false;
  }
});

const rootElement = document.getElementById('root');

if (!rootElement) {
  console.error("Element with id 'root' not found.");
} else {
  const root = createRoot(rootElement);
  // Print any logs persisted across redirects, then clear them
  try {
    flushPersistedLogs();
  } catch (_err) {}
  initializeMsal().finally(() => {
    root.render(
      process.env.NODE_ENV === 'development' ? (
        <React.StrictMode>
          <MsalProvider instance={msalInstance}>
            <PermissionProvider>
              <Provider store={redux.store}>
                <BrowserRouter basename={base_path}>
                  <AllRoutes />
                </BrowserRouter>
              </Provider>
            </PermissionProvider>
          </MsalProvider>
        </React.StrictMode>
      ) : (
        <MsalProvider instance={msalInstance}>
          <PermissionProvider>
            <Provider store={redux.store}>
              <BrowserRouter basename={base_path}>
                <AllRoutes />
              </BrowserRouter>
            </Provider>
          </PermissionProvider>
        </MsalProvider>
      ),
    );
    
    // Register the service worker for PWA support
    serviceWorkerRegistration.register({
      onUpdate: registration => {
        // Automatically reload the page when a new version is available
        if (registration && registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
        window.location.reload();
      }
    });
  });
}
